export const getCoinDisplayName = (coinName) => {
    const displayNameMap = {
        SUIBTC: 'wBTC',
        TBTC: 'tBTC',
        STSUI: 'stSUI',
        XAUM: 'XAUm',
        WUSDC: 'wUSDC',
        MUSD: 'mUSD',
        SUIUSDT: 'suiUSDT',
        VSUI: 'vSUI',
        ESUI: 'eSUI',
        AFSUI: 'afSUI',
        EBTC: 'eBTC',
        EGUSDC: 'egUSDC',
        HASUI: 'haSUI',
    };
    return displayNameMap[coinName] || coinName;
};
